import type { ComponentType } from 'react';
import {
  AdminAllRequests,
  AdminOverview,
  ApproverApproved,
  ApproverPending,
  ApproverRejected,
  ApproverReports,
  ChiefApproverDashboard,
  EmployeeDashboard,
  ManagerDashboard,
  PurchaseReports,
  PurchaseRequestScreen,
} from './screens';

/**
 * Which component serves each `/purchasing/:role/:section` route.
 *
 * Keys match the nav item keys in src/app/navigation.ts. Anything not listed
 * falls through to the placeholder — `user-management` and `system-settings` are
 * Phase 8 and still do.
 */
export const PURCHASING_SCREENS: Record<string, Record<string, ComponentType>> = {
  employee: {
    dashboard: EmployeeDashboard,
    'purchase-request': PurchaseRequestScreen,
  },
  approver: {
    pending: ApproverPending,
    approved: ApproverApproved,
    rejected: ApproverRejected,
  },
  'chief-approver': {
    dashboard: ChiefApproverDashboard,
  },
  manager: {
    dashboard: ManagerDashboard,
    'approver-reports': ApproverReports,
    'purchase-reports': PurchaseReports,
  },
  admin: {
    'all-requests': AdminAllRequests,
    overview: AdminOverview,
  },
};
